import { useState } from "react";
// import { MdArrowDownward, MdArrowForward } from "react-icons/md";
import SignalStrength from "./signal-strength";
import RoundedCheckIcon from "../../../../../../components/icons/chevron-right";

function ExpandedContent({ deviceSignals = [] }) {
  return (
    <div style={{ borderBottom: "1px solid #dfe2e6" }}>
      <SignalStrength data={deviceSignals}></SignalStrength>
    </div>
  );
}

export default function WifiDevicesList({
  columns = [],
  lines = [],
  connectedDevicesSignal = [],
}) {
  const [expandedLines, setExpandedLines] = useState([]);

  function onLineClick(lineIndex) {
    setExpandedLines((oldValue) => {
      if (oldValue.includes(lineIndex))
        return oldValue.filter((value) => value !== lineIndex);
      return [...oldValue, lineIndex];
    });
  }
  return (
    <div className="list">
      <div className="list-headers">
        {columns.map((col, index) => {
          return (
            <div
              className="list-header-item"
              key={index}
              style={{
                maxWidth: col?.size ?? "auto",
                textAlign: col?.align ?? "left",
              }}
            >
              {col.header}
            </div>
          );
        })}
      </div>
      <div className="list-lines">
        {lines?.length
          ? lines.map((line, lineIndex) => {
              const hostname = line[0];

              return (
                <>
                  <div
                    className="list-line-entry"
                    key={lineIndex}
                    style={{ cursor: "pointer" }}
                    onClick={() => onLineClick(lineIndex)}
                  >
                    {line.map((lineCol, lineColIndex) => {
                      const firstCol = lineColIndex === 0;
                      return (
                        <div
                          className="list-line-item"
                          key={lineColIndex}
                          style={{
                            maxWidth: columns[lineColIndex]?.size ?? "none",
                            textAlign: columns[lineColIndex]?.align ?? "left",
                            margin: "8px 0",
                          }}
                        >
                          {firstCol ? (
                            <div style={{ display: "flex", gap: "10px" }}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  transform: expandedLines.includes(lineIndex)
                                    ? "rotate(90deg)"
                                    : "rotate(0)",
                                  paddingRight: "5px",
                                }}
                              >
                                {expandedLines.includes(lineIndex) ? (
                                  <RoundedCheckIcon size={20} />
                                ) : (
                                  <RoundedCheckIcon size={20} />
                                )}
                              </div>

                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {lineCol}
                              </span>
                            </div>
                          ) : (
                            <span>{lineCol}</span>
                          )}
                        </div>
                      );
                    })}
                  </div>
                  {expandedLines.includes(lineIndex) ? (
                    <ExpandedContent
                      deviceSignals={connectedDevicesSignal[hostname] ?? []}
                      key={lineIndex + "-expanded"}
                    />
                  ) : null}
                </>
              );
            })
          : null}
      </div>
    </div>
  );
}
